module.exports = __webpack_public_path__ + "img/Shopping_cart_with_food_clip_art_2.f742cf9e.svg";